/*
 * Bundle parts on desktop (sections/bundle-parts.liquid): while the texts scroll past the sticky
 * image, the image of the text in view fades in. A text shows once its top passes the lower part
 * of the image, and hides again when scrolling back up.
 */
(() => {
  if (customElements.get('bundle-parts')) return;

  class BundleParts extends HTMLElement {
    connectedCallback() {
      this.contents = Array.from(this.querySelectorAll('[data-part-content]'));
      this.images = Array.from(this.querySelectorAll('.bundle-parts__media > *'));
      if (this.contents.length < 2) return;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, {passive: true});
      window.addEventListener('resize', this.onScroll, {passive: true});
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const image = this.images[0];
      // Hidden on mobile, where the cards row is shown instead.
      if (!image || !image.offsetParent) return;

      const imageRect = image.getBoundingClientRect();
      const line = imageRect.bottom - imageRect.height * 0.15;
      let active = 0;
      this.contents.forEach((content, index) => {
        if (index > 0 && content.getBoundingClientRect().top < line) active = index;
      });

      this.contents.forEach((content, index) => content.classList.toggle('is-visible', index <= active));
      this.images.forEach((img, index) => img.classList.toggle('is-visible', index <= active));
    }
  }

  customElements.define('bundle-parts', BundleParts);
})();
